import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '../../rootReducer';

import { FetchingCreditsPoolStatus } from './creditsPools.slice';

type Self = RootState['credits']['creditsPools'];

const selectSelf = (state: RootState): Self => state.credits.creditsPools;

export const selectActiveCreditsPoolsIds = (state: RootState):Self['idsListOfActive'] => selectSelf(state).idsListOfActive;

export const selectActiveCreditsPoolsIdsCount = (state: RootState):number => selectActiveCreditsPoolsIds(state).length;

export const selectArchivedCreditsPoolsIds = (state: RootState):Self['idsListOfArchived'] => selectSelf(state).idsListOfArchived;

export const selectArchivedCreditsPoolsIdsCount = (state: RootState):number => selectArchivedCreditsPoolsIds(state).length;

export const selectMapOfAllCreditsPools = (state: RootState):Self['map'] => selectSelf(state).map;

export const selectCreditPoolsLoading = (state: RootState): boolean => selectSelf(state).fetchingCreditsPoolsStatus === FetchingCreditsPoolStatus.Loading;

export const selectAllCreditsPoolsCount = createSelector(
  [selectActiveCreditsPoolsIds, selectArchivedCreditsPoolsIds],
  (idsOfActive, idsOfArchived) => {
    return (idsOfActive.length + idsOfArchived.length);
  }
);

export const selectActiveCreditsPools = createSelector(
  [selectActiveCreditsPoolsIds, selectMapOfAllCreditsPools],
  (ids, map) => {
    return ids.map((id) => map[id]);
  }
);

export const selectArchivedCreditsPools = createSelector(
  [selectArchivedCreditsPoolsIds, selectMapOfAllCreditsPools],
  (ids, map) => {
    return ids.map((id) => map[id]);
  }
);

export const selectCurrentViewActiveVsArchived = (state: RootState): Self['currentView'] => selectSelf(state).currentView;

